const priorityMailData = {
  0.1: {
    "1": 7.00,
    "2": 7.01,
    "3": 7.05,
    "4": 7.15,
    "5": 8.18,
    "6": 8.79,
    "7": 10.07,
    "8": 10.85,
  },
  0.2: {
   "1": 7.00,
   "2": 7.13,
   "3": 7.15,
   "4": 7.18,
   "5": 8.82,
   "6": 9.94,
    "7": 11.97,
    "8": 13.17,
  },
  0.3: {
    "1": 7.00,
    "2": 7.20,
    "3": 7.20,
    "4": 7.20,
    "5": 9.59,
    "6": 13.74,
    "7": 15.48,
    "8": 18.45,
  },
  0.4: {
    "1": 7.00,
    "2": 7.20,
    "3": 7.20,
    "4": 7.23,
    "5":12.38,
    "6":16.41,
    "7":19.31,
    "8":22.48,
  },
  0.5: {
    "1": 7.00,
    "2": 7.20,
    "3": 7.20,
    "4": 7.59,
    "5": 13.89,
    "6": 18.32,
    "7": 22.97,
    "8": 26.76,
  },
}

const parcelSelectGroundData = {
  0.1: {
    "1": 6.34,
    "2": 6.42,
    "3": 6.50,
    "4": 6.62,
    "5": 7.52,
    "6": 7.74,
    "7": 8.19,
    "8": 8.56,
    "9": 8.56,
  },
  0.2: {
    "1": 6.54,
    "2": 6.64,
    "3": 6.71,
    "4": 6.86,
    "5": 8.08,
    "6": 8.98,
    "7": 9.57,
    "8": 10.12,
    "9": 10.12,
  },
  0.3: {
    "1": 6.66,
    "2": 6.78,
    "3": 6.85,
    "4": 7.01,
    "5": 8.55,
    "6": 10.48,
    "7": 11.01,
    "8": 11.64,
    "9": 11.64,
  },
  0.4: {
    "1": 6.78,
    "2": 6.93,
    "3": 6.99,
    "4": 7.18,
    "5": 9.53,
    "6": 11.47,
    "7": 12.14,
    "8": 12.76,
    "9": 12.7,
  },
  0.5: {
    "1": 6.90,
    "2": 7.09,
    "3": 7.13,
    "4": 7.38,
    "5": 10.23,
    "6": 12.16,
    "7": 12.93,
    "8": 13.66,
    "9": 13.66,
  },
  0.6: {
    "1": 7.01,
    "2": 7.27,
    "3": 7.48,
    "4": 7.77,
    "5": 11.72,
    "6": 12.68,
    "7": 13.45,
    "8": 14.22,
    "9": 14.22,
  },
  0.7: {
    "1": 7.77,
    "2": 7.88,
    "3": 8.74,
    "4": 9.34,
    "5": 12.56,
    "6": 13.01,
    "7": 13.91,
    "8": 14.86,
    "9": 14.86,
  },
  0.8: {
    "1": 8.13,
    "2": 8.32,
    "3": 9.45,
    "4": 10.20,
    "5": 12.91,
    "6": 13.48,
    "7": 14.40,
    "8": 15.50,
    "9": 15.50,
  },
  0.9: {
    "1": 8.70,
    "2": 8.79,
    "3": 9.94,
    "4": 10.77,
    "5": 13.14,
    "6": 13.90,
    "7": 15.09,
    "8": 16.42,
    "9": 16.42,
  },
  1.0: {
    "1": 9.29,
    "2": 9.38,
    "3": 10.45,
    "4": 11.37,
    "5": 13.54,
    "6": 14.33,
    "7": 16.10,
    "8": 17.68,
    "9": 17.68
  }
}

export default {
  isCubicWeight(tier, zone, rate, service=null) {
    switch (service) {
      case 'PRCLSEL':
        if (parcelSelectGroundData[tier] !== undefined && parcelSelectGroundData[tier][zone] === rate) {
          return true;
        }
        return false;
      default:
        if (priorityMailData[tier] !== undefined && priorityMailData[tier][zone] === rate) {
          return true;
        }
        return false;
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/data/cubic-weight.js